import { Component } from '@angular/core';

@Component({
  selector: 'app-ocr-pdf-content',
  imports: [],
  templateUrl: './ocr-pdf-content.component.html',
  styleUrl: './ocr-pdf-content.component.css'
})
export class OcrPdfContentComponent {

}
